"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "FRIDAY": "Penktadienis",
    "MONDAY": "Pirmadienis",
    "SATURDAY": "Šeštadienis",
    "SUNDAY": "Sekmadienis",
    "THURSDAY": "Ketvirtadienis",
    "TUESDAY": "Antradienis",
    "WEDNESDAY": "Trečiadienį",
    "and": "ir",
    "day_few": "dienos",
    "day_many": "dienos",
    "day_one": "diena",
    "day_other": "dienos",
    "day_plural": "dienos",
    "freeOfCharge": "Nemokama",
    "hour_one": "valanda",
    "hour_one_plural": "valandos",
    "hour_other": "valandos",
    "minute_few": "minutė",
    "minute_many": "minutė",
    "minute_one": "minutė",
    "minute_other": "minutės",
    "ocpiRestrictionsAfterDuration": "Po {{minDuration}}",
    "ocpiRestrictionsBetweenDuration": "Nuo {{minDuration}} iki {{maxDuration}}",
    "ocpiRestrictionsFirstDuration": "Pirmasis {{maxDuration}}",
    "ocpiRestrictionsKwhAbove": "Kai energijos sąnaudos viršija {{minKwh}}",
    "ocpiRestrictionsKwhBetween": "Kai energijos suvartojama nuo {{minKwh}} iki {{maxKwh}}",
    "ocpiRestrictionsKwhLessThan": "Kai sunaudojama mažiau energijos nei {{maxKwh}}",
    "session": "sesija",
    "theDay_few": "diena",
    "theDay_many": "diena",
    "theDay_one": "diena",
    "theDay_other": "dienos",
    "theHour_few": "valanda",
    "theHour_many": "valanda",
    "theHour_one": "valanda",
    "theHour_other": "valandos",
    "theMinute_few": "minutė",
    "theMinute_many": "minutė",
    "theMinute_one": "minutė",
    "theMinute_other": "minutės"
};
